import { defineComponent } from "vue";
import { u as useVaRatingColorsProps, a as useVaRatingColors } from "../hooks/useVaRatingColors-a49be451.mjs";
import { u as useSizeProps, a as useSize } from "../../../composables/useSize-73067570.mjs";
const _sfc_main = defineComponent({
  name: "VaRatingItemNumberButton",
  props: {
    ...useVaRatingColorsProps,
    ...useSizeProps,
    itemNumber: { type: Number, required: true },
    modelValue: { type: Number, required: true }
  },
  setup(props) {
    return {
      ...useVaRatingColors(props),
      ...useSize(props, "VaRating")
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaRatingItemNumberButton.vue_vue_type_script_lang-9414ee76.mjs.map
